import React from 'react';

import { FormLabel, Stack, TextField } from '@mui/material';

interface Props {
  label: string;
  value?: number;
  onChange: (value: number | undefined) => void;
}

export default function PackageNumberField({ label, value, onChange }: Props) {
  return (
    <Stack spacing={1}>
      <FormLabel>{label}</FormLabel>
      <TextField
        type="number"
        value={value ?? ''}
        size="small"
        fullWidth
        slotProps={{ htmlInput: { min: 0 } }}
        onChange={(event) => onChange(parseNumberInput(event.target.value))}
      />
    </Stack>
  );
}

function parseNumberInput(value: string) {
  if (value === '') {
    return undefined;
  }

  const parsedValue = Number(value);

  return Number.isFinite(parsedValue) ? parsedValue : undefined;
}
